{
	"title": "Tjenesten er utilgjengelig (500)",
	"description": "Prøv å oppdatere denne siden eller sjekk internettforbindelsen din. Hvis denne feilen vedvarer, vennligst rapporter den som en feil, slik at vi kan iverksette tiltak.",
	"primaryButtonTitle": "Oppdater siden",
	"secondaryButtonTitle": "Kopier feillogg",
	"errorLogCopiedMessage": "Feillogg kopiert",
	"traceparentLabel": "Traceparent"
}
